<template>
        <v-row
            align="center">
            <v-col>
                <v-autocomplete outlined dense
					hide-details="auto"
                    class="mt-0 pt-0"
                    :disabled="NoData"
                    v-model="organization.selected"
                    :items="organization.items"
                    solo
                    flat
                    :readonly="HasOnlyOneOrganization"
                    :loading="loading">
                </v-autocomplete>
            </v-col>
        </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import userActions from '../store/actions/user';
import organizationActions from '../store/actions/organization';
import namespace from '../store/namespace';

export default {
	name: 'OrganizationSelector',
	data() {
		return {
			organization: {
				items: [],
				selected: '',
			},
			oldOrga: null,
			loading: false,
		};
	},
	async mounted() {

		await this.getOrganization();
		this.$router.onError((e) => {
			if (e.message === 'notSavedAborted' && this.oldOrga !== this.Organization) {
				this.organization.selected = this.oldOrga;
			}
		});
		this.$router.afterEach(() => {
			this.oldOrga = this.Organization;
		});
	},
	computed: {
		...mapGetters(namespace.ORGANIZATION, ['HasOrganization', 'Organization']),
		NoData() {
			return this.organization.items.length === 0;
		},
		HasOnlyOneOrganization() {
			return this.organization.items.length === 1;
		},
	},
	watch: {
		'organization.selected': async function () {
			if (this.organization.selected.length) {
				const globalOrg = this.organization.items
					.find(x => x.value === this.organization.selected);
				if (this.organization.selected !== this.oldOrga) this.oldOrga = this.Organization;

				await this.SET_GLOBAL_ORGANIZATION(globalOrg);
				await this.GET_USER_ROLES(this.organization.selected);

				if (this.organization.selected !== this.oldOrga) {
					if (this.$route.meta.parentName) {
						this.$router.push({ name: this.$route.meta.parentName });
					} else {
						this.$router.push('/redirector');
					}
				}
			}
		},
	},
	methods: {
		...mapActions(namespace.USER, [userActions.GET_ORGANIZATIONS, userActions.GET_USER_ROLES]),
		...mapActions(namespace.ORGANIZATION, [organizationActions.SET_GLOBAL_ORGANIZATION]),
		...mapMutations(namespace.ORGANIZATION, [organizationActions.SET_ORGANIZATIONS]),
		async getOrganization() {
			this.loading = true;
			try {
				this.organization.items = await this.GET_ORGANIZATIONS();
				this.SET_ORGANIZATIONS(this.organization.items);

				if (this.HasOrganization) {
					this.organization.selected = this.Organization;
				} else if (this.organization.items.length > 0) {
					this.organization.selected = this.organization.items[0].value;
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.global-organization {
    padding-left: 15px;
}
</style>
